import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './FadeIn';
const faqs = [{
  q: '¿Tengo que dejarlo llorar?',
  a: 'No. En ningún momento tu bebé se queda solo llorando. El método se basa en acompañarlo de forma gradual, estando presente mientras aprende a regularse. Es respetuoso y amoroso.'
}, {
  q: '¿Funciona si hacemos colecho?',
  a: 'Sí, totalmente. La guía incluye indicaciones tanto para cuna como para cama compartida. Se adapta a la forma en que tu familia duerme hoy.'
}, {
  q: '¿A qué edad se puede empezar?',
  a: 'Está pensada para bebés de 4 meses a 2 años. Si tu bebé está en ese rango, podés empezar esta misma noche.'
}, {
  q: '¿Cuánto tiempo toma ver resultados?',
  a: 'La mayoría de las mamás notan cambios desde la segunda o tercera noche. No es magia, pero con constancia los resultados llegan rápido.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-cream py-24 px-6 md:px-12" data-id="element-14">
      <div className="max-w-3xl mx-auto" data-id="element-15">
        <FadeIn data-id="element-16">
          <h2 className="text-4xl md:text-5xl text-center mb-12" data-id="element-17">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-18">
          {faqs.map((faq, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-19">
              <div className="bg-white rounded-2xl shadow-sm border border-brown/5 overflow-hidden" data-id="element-20">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-21">
                  <span className="text-lg font-semibold text-brown" data-id="element-22">
                    {faq.q}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} data-id="element-23">
                    <ChevronDown className="w-5 h-5 text-periwinkle" data-id="element-24" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-25">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-26">
                      <div className="px-6 pb-5 text-brown/70 text-lg" data-id="element-27">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}